export const emptyPhone = { country_code: null, phone: null }
